class Clients {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  update(client) {
    return this.apiClient.put(`com/clients/${client.id}/billing`, client.getUpdatePayload()).then(response => response.data);
  }
}

export { Clients };
//# sourceMappingURL=Clients.js.map
